<template>
  <div id="dateRange">
    <label class="mr-1">Dates: </label>
    <select class="mr-2" v-model="activeRange">
      <option value="ALL">All Dates</option>
      <option value="TODAY">Today</option>
      <option value="WEEK">This Week</option>
      <option value="MONTH">This Month</option>
      <option value="NEXT">Next Month</option>
    </select>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'DateRange',
  computed: {
    ...mapState(['activeRange']),
    ...mapGetters(['startDate', 'endDate']),
    disabledStart () {
      return { to: moment().subtract(1, 'day').toDate() }
    },
    disabledEnd () {
      return { to: this.startDate.toDate() }
    },
    activeRange: {
      get () {
        return this.$store.state.activeRange
      },
      set (range) {
        this.SET_ACTIVE_RANGE(range)
        this.retrieveEvents()
      }
    }
  },
  watch: {
    startDate () {
      if (this.endDate.isBefore(this.startDate)) {
        this.SET_END_DATE(moment(this.startDate).add(1, 'month').endOf('day'))
      }
    }
  },
  methods: {
    ...mapMutations(['SET_END_DATE', 'SET_START_DATE', 'SET_ACTIVE_RANGE']),
    ...mapActions(['retrieveEvents']),
    setStartDate (date) {
      this.SET_START_DATE(date)
      this.retrieveEvents()
    },
    setEndDate (date) {
      this.SET_END_DATE(date)
      this.retrieveEvents()
    }
  }
}
</script>
